<template>
    <div class="verAddCon"   v-if='showModel'>

        <div class="title">{{$t('homePage.Associated')}}</div>
        <Icon class="colseButton" type="ios-close-circle" size='30' style="color:#ed4014" @click="cancel" />
    

        <div class="top">
            <Button type="success" class="addButton"  @click="addData(1)" style="margin-right:8px;">{{$t("userManage.associate.addTitle")}}</Button>
        </div>

        <Table  max-height="500" :border="true" :columns="titleName" :data="tableList.tableData" :loading="loading"></Table>

        <!-- 关联用户 -->
		<ModelAddBox :showModel.sync="addBox.showModel" :fn="addBox.callbackFn"  :editFormData="addBox.editFormData"></ModelAddBox>

    </div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
import ModelAddBox from './addAssociatModel.vue';

import { mapMutations,mapState } from 'vuex'

    export default {
        name: "settingModel",
        props: {
            showModel: Boolean,
            offModel: Boolean,
            fn:Function,
            editFormData:Object,
        },
        components: {
            ModelAddBox
        },
        data() {
            return {   
                totalNum:'20',
                loading:false,
                tableList:{//表格组
                    hasSelectData:{},//已选中的行的数据
                    tableData: []//表格数据
                },
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                addBox:{
			    	showModel:false,
			    	callbackFn:()=>{},
			    	editFormData:{}
			    }
            }
        },
       
        computed:{
            ...mapState(['local','selectId','uInfo']),
            titleName(){
                return [
                    {
                        title: this.$t('userManage.titleName.Account'),
                        'title-zh-CN':'账号',
                        key: 'id',
                        minWidth: 100
                    },
                   
                    {
                         title: this.$t('userManage.titleName.Email'),
                         'title-zh-CN':'邮箱',
                         'title-en-US':'Email',
                         key: 'emailAddress',
                        //  sortable: true,
                         minWidth: 260
                     },
                     {
                        title: this.$t('userManage.titleName.Phone'),
                        'title-zh-CN':'联系电话',
                        'title-en-US':'Phone',
                        key: 'phoneNumber',
                        minWidth: 150,
                        // render:(h, params)=>{
                        //      let stext = params.row.phonePrefix?params.row.phonePrefix+'-'+params.row.phoneNumber:params.row.phoneNumber
                        //      return h('div',stext || '')
                        // }
                    },
                    {
                        title: this.$t('orderManage.titleName.Operation'),
                        'title-zh-CN':'操作',
                        key: 'devideAttrRef',
                        minWidth: 130,
                        render: (h, params) => {
                        let that = this
                        return h('div',{
                            style:{
                                display:'flex',
                                'justify-content':'center'
                            }
                        },[
                           
                            h('Poptip', 
                                {
                                     props: {
                                         confirm: true,
                                         transfer:true,
                                         type: 'error',
                                         size: 'large',
                                         title:that.$t("deviceManage.UnbundlingCont")
                                     },
                                     on: {
                                         'on-ok': () => {
                                             that.unbundlingCont(params.row)
                                         }
                                     }
                                 }, 
                                 [
                                     h('Button', {
                                         props: {
                                             type: 'error',
                                             size: 'small',
                                         },
                                         style: {
                                             marginRight: '5px',
                                             display:'inline-block'
                                         },
                                     },that.$t("deviceManage.Unbundling"))
                                ]
                            )
                           
                        ])
		            }
                    }
                 ]
            } 

        },
        created(){
          
        },
        watch:{
            showModel(val){
                if(val === true) {   
                    this.getData()
                } else { //关闭弹框后要做的处理
                    this.resetForm();
                }
            },
            
        },
        methods: {
             ...mapMutations([
              'setLocal'
            ]),
            unbundlingCont(row){
                this.axios.post(this.config.urlArray.changeAdminMember, {
                    userId:row.userId,
                    adminMember:false
                }).then((result) => {
                    common.ajaxMsg(result.data,true,()=>{
                        this.loading = true
                        this.getData()
                    });

                }).catch((err) => {
                    // common.msg('error','获取失败',()=>{})
                });
            },
            addData(){
		    	this.addBox.showModel = true
                this.addBox.callbackFn = () => {
                    this.addBox.showModel = false;
                    this.getData();
                }
		    },
            getData() {//获取数据
                let params= {}

                this.axios.post(this.config.urlArray.getDealerAdminMember, params).then((result) => {
                    // common.ajaxMsg(result.data);
                    let resData = result.data.data
                    //处理数组
                    this.tableList.tableData  = result.data.data
                    let total = result.data.data.length
                    this.fn(total)
                    this.loading = false

                }).catch((err) => {
                    this.loading = false
                    // common.msg('error','获取失败',()=>{})
                });
            },
            resetForm() {//重置表单
                this.disabled = false;
            },
            cancel() {//对话框关闭
                this.$emit('update:showModel',false);
                this.$emit('update:offModel',true);
            }
        }
    }
</script>
<style lang="less" scoped>
.simple-size {
    color: #ccc;
    font-size: 12px;
    height: 20px;
    padding: 0;
    margin: 0;
}
.logoCon /deep/ .ivu-form-item-content{
    margin-left: 0px !important;
}
.verAddCon{
    position: relative;
    .title{
        font-size: 20px;
        padding: 4px 0 20px;
    }
    .colseButton{
        position: absolute;
        right: -18px;
        top:-18px;
        cursor: pointer;
    }
}
/deep/ .ivu-form .ivu-form-item-label{
    width: 160px !important;
    flex-shrink: 0;
}
/deep/ .ivu-form-item-content {
    margin-left: 160px !important;
    flex-grow: 1;
}

</style>
